
import { Component, Prop, Vue } from 'vue-property-decorator'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'
import Radio from '~/components/common/input/Radio.vue'
import Icon from '~/components/common/icon/Icon.vue'
import DashboardButton from '~/components/common/buttons/DashboardButton.vue'

import { ReportOptions } from '~/store/cardReport'

@Component({
  name: 'DashboardReportModal',
  components: {
    CloseCrossCtrl,
    Radio,
    Icon,
    DashboardButton
  }
})
export default class DashboardReportModal extends Vue {
  @Prop({ type: Number, required: true }) scholarshipId!: number
  @Prop({ type: Function, required: true }) onSuccess!: () => void
  @Prop({ type: Function, required: true }) onReject!: (err) => void

  isReporting = false

  selected = -1
  text = ''

  get remaining() {
    return 500 - this.text.length
  }

  get options() {
    return this.$accessor.cardReport.options
  }

  get isDisabled() {
    return this.selected <= -1 || (this.options.find((opt: ReportOptions) => opt.id === this.selected).isAllowDetails && this.text.length <= 9)
  }

  close() {
    this.$emit('close')
  }

  report() {
    const opt: { scholarshipId: number; optionId: number; details?: string; } = {
      scholarshipId: this.scholarshipId,
      optionId: this.selected,
      details: this.text
    }

    if (!this.text) {
      delete opt.details
    }
    if (!this.isReporting) {
      this.isReporting = true
      this.$accessor.cardReport.reportScholarship(opt)
        .then(() => {
          this.close()
          this.onSuccess()
        })
        .catch((err) => {
          this.close()
          this.onReject(err)
        })
    }
  }
}
